/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Lets an impersonation control stay interactive while a driver.js tutorial
 * overlay is active. Both the expanded banner and its collapsed tab must use
 * this wrapper so they stay above the overlay and receive pointer events.
 */
const TutorialOverlayExempt = React.forwardRef(({
  as: Element = 'div', children, ...props
}, ref) => (
  <Element
    {...props}
    ref={ref}
    data-tutorial-overlay-exempt="true"
  >
    {children}
  </Element>
));

TutorialOverlayExempt.displayName = 'TutorialOverlayExempt';

TutorialOverlayExempt.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
};

TutorialOverlayExempt.defaultProps = {
  as: 'div',
  children: null,
};

export default TutorialOverlayExempt;
